import { createStore } from 'vuex'
import personalModule from './modules/personalSeleccionado'

const store = createStore({

  modules: {
    personal: personalModule,
  },

});

export default store;